import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./InvoicePage.css";

const InvoicePage = () => {
  const { id: businessId } = useParams();
  const navigate = useNavigate();

  const [business, setBusiness] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState("");
  const [taxRate, setTaxRate] = useState("");
  const [editingTax, setEditingTax] = useState(false);
  const [savingTax, setSavingTax] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  useEffect(() => {
    const fetchBusiness = async () => {
      try {
        const { data } = await api.get(`/businesses/${businessId}`);
        setBusiness(data);

        if (data.logo_url) {
          setLogoUrl(data.logo_url);
        }

        if (data.sales_tax_rate !== null && data.sales_tax_rate !== undefined) {
          setTaxRate(data.sales_tax_rate);
        } else {
          setTaxRate("");
        }
      } catch (err) {
        console.error("Error fetching business:", err);
      }
    };

    fetchBusiness();
  }, [businessId]);

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0] || null;
    setLogoFile(file);
  };

  const uploadLogo = async () => {
    if (!logoFile) {
      alert("Select a logo first.");
      return;
    }

    const formData = new FormData();
    formData.append("logo", logoFile);

    try {
      setUploadingLogo(true);

      const { data } = await api.post(
        `/business/${businessId}/upload-logo`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setLogoUrl(data.url);
      setLogoFile(null);
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Logo upload failed.");
    } finally {
      setUploadingLogo(false);
    }
  };

  const saveTaxRate = async () => {
    try {
      setSavingTax(true);
      await api.put(`/business/${businessId}/update-tax-rate`, {
        sales_tax_rate: taxRate,
      });
      setEditingTax(false);
    } catch (err) {
      console.error(err);
      alert("Failed to update tax rate.");
    } finally {
      setSavingTax(false);
    }
  };

  if (!business) {
    return <p className="invoice-page-loading">Loading business data...</p>;
  }

  return (
    <div className="invoice-page">
      <div className="invoice-page-header">
        <div>
          <p className="invoice-page-subtitle">
            Manage logo, sales tax, customers, and products for{" "}
            <strong>{business.name || "this business"}</strong>.
          </p>
        </div>

        
      </div>

      <div className="invoice-page-grid">
        <div className="invoice-page-card">
          <div className="invoice-page-card-header">
            <h2>Business Logo</h2>
            <p>Upload or replace the logo used on invoices.</p>
          </div>



          

          <div className="invoice-page-logo-panel">
            <div className="invoice-page-logo-preview">
              {logoUrl ? (
                <img
                  src={`https://payweek.com/api/uploads/invoices/${logoUrl.split("/").pop()}`}
                  alt="Business Logo"
                />
              ) : (
                <div className="invoice-page-logo-empty">
                  No logo uploaded yet
                </div>
              )}
            </div>

            <div className="invoice-page-logo-controls">
              <label className="invoice-page-field-label" htmlFor="invoiceLogo">
                Select Logo
              </label>

              <input
                id="invoiceLogo"
                type="file"
                onChange={handleLogoChange}
                className="invoice-page-file-input"
              />

              <button
                type="button"
                className="invoice-page-btn invoice-page-btn-success"
                onClick={uploadLogo}
                disabled={uploadingLogo}
              >
                {uploadingLogo ? "Uploading..." : "Submit Logo"}
              </button>
            </div>
          </div>
        </div>

<div className="invoice-page-card">
  <div className="invoice-page-card-header">
    <h2>Management</h2>
    <p>Open the related invoice setup sections.</p>
  </div>

  <div className="invoice-page-actions">
    <button
      type="button"
      className="invoice-page-btn invoice-page-btn-dark"
      onClick={() => navigate(`/dashboard/business/${businessId}/vendors`)}
    >
      Manage Customers
    </button>

    <button
      type="button"
      className="invoice-page-btn invoice-page-btn-dark"
      onClick={() => navigate(`/dashboard/business/${businessId}/products`)}
    >
      Manage Products
    </button>
  </div>

  <div className="invoice-page-sales-tax-section">
    <div className="invoice-page-card-header">
      <h2>Sales Tax Rate</h2>
      <p>Set the default tax rate used in invoice calculations.</p>
    </div>

    {!editingTax ? (
      <div className="invoice-page-tax-display">
        <div className="invoice-page-tax-value">
          {taxRate !== "" && taxRate !== null ? `${taxRate}%` : "Not set"}
        </div>

        <button
          type="button"
          className="invoice-page-inline-btn"
          onClick={() => setEditingTax(true)}
        >
          Edit
        </button>
      </div>
    ) : (
      <div className="invoice-page-tax-edit">
        <div className="invoice-page-field">
          <label
            className="invoice-page-field-label"
            htmlFor="invoiceTaxRate"
          >
            Sales Tax Rate
          </label>

          <input
            id="invoiceTaxRate"
            type="number"
            step="0.01"
            placeholder="e.g. 8.25"
            value={taxRate}
            onChange={(e) => setTaxRate(e.target.value)}
            className="invoice-page-input"
          />
        </div>

        <div className="invoice-page-tax-actions">
          <button
            type="button"
            className="invoice-page-btn invoice-page-btn-primary"
            onClick={saveTaxRate}
            disabled={savingTax}
          >
            {savingTax ? "Saving..." : "Save"}
          </button>

          <button
            type="button"
            className="invoice-page-btn invoice-page-btn-secondary"
            onClick={() => setEditingTax(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    )}
  </div>
</div>

        
      </div>

      
    </div>
  );
};

export default InvoicePage;



// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import api from "../services/api";
// import "./InvoicePage.css"; // Optional, for styling

// const InvoicePage = () => {
//   const { id: businessId } = useParams();

//   const [business, setBusiness] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const navigate = useNavigate();
//   const [logoUrl, setLogoUrl] = useState("");
//   const [taxRate, setTaxRate] = useState("");
//   const [editingTax, setEditingTax] = useState(false);


//   // Fetch business and logo
//   useEffect(() => {
//     const fetchBusiness = async () => {
//       try {
//         const { data } = await api.get(`/businesses/${businessId}`);
//         setBusiness(data);
//         if (data.logo_url) setLogoUrl(data.logo_url);

//         if (data.sales_tax_rate !== null) {
//           setTaxRate(data.sales_tax_rate);
//         }


//       } catch (err) {
//         console.error("Error fetching business:", err);
//       }
//     };

//     fetchBusiness();
//   }, [businessId]);

//   const handleLogoChange = (e) => {
//     setLogoFile(e.target.files[0]);
//   };

//   const uploadLogo = async () => {
//     if (!logoFile) return alert("Select a logo first.");
//     const formData = new FormData();
//     formData.append("logo", logoFile);

//     try {
//       const { data } = await api.post(`/business/${businessId}/upload-logo`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       setLogoUrl(data.url);
//     } catch (err) {
//       console.error("Upload failed:", err);
//       alert("Logo upload failed.");
//     }
//   };

//   if (!business) return <p>Loading business data...</p>;

//   return (
//     <div className="invoice-container">
//     <button className="invoice-save" onClick={() => navigate(`/dashboard/business/${businessId}/invoiceref`)}>Invoices</button>
//       <h4 className="invoice-title">Invoice Settings</h4>

//       <div className="logo-section">
//         {logoUrl ? (
//           <div className="logo-preview">

//           <img src={`https://payweek.com/api${logoUrl}`} alt="Business Logo" />



//           {/* <img src={`http://localhost:5000${logoUrl}`} alt="Business Logo" /> */}

            
//           </div>
//         ) : (
//           <p>No logo uploaded yet.</p>
//         )}
//         <div className="logo-submit">
//         <input type="file" placeholder="logo file" onChange={handleLogoChange} />
//         <button className="add-logo-btn" onClick={uploadLogo}>Submit Logo</button>
//         </div>
//       </div>

//       <div className="tax-rate-section">
//   <label>Sales Tax Rate</label>
//   {editingTax ? (
//     <div>
//       <input
//         type="number"
//         step="0.01"
//         placeholder="e.g. 8.25"
//         value={taxRate}
//         onChange={(e) => setTaxRate(e.target.value)}
//       />
//       <button
//        onClick={async () => {
//         try {
//           await api.put(`/business/${businessId}/update-tax-rate`, { sales_tax_rate: taxRate });
//           setEditingTax(false);
//         } catch (err) {
//           console.error(err);
//           alert("Failed to update tax rate.");
//         }
//       }}>
//         Save
//       </button>
//     </div>
//   ) : (
//     <div>
//       <span>{taxRate ? `${taxRate}%` : "Not set"}</span>{" "}
//       <button onClick={() => setEditingTax(true)}>✏️ Edit</button>
//     </div>
//   )}
// </div>

// <div className="inv-buttons">

//       <button className="manage-customer" onClick={() => navigate(`/dashboard/business/${businessId}/vendors`)}>Manage Customers</button>

//       <button className="manage-products" onClick={() => navigate(`/dashboard/business/${businessId}/products`)}>Manage Products</button>


// </div>
//       {/* More invoice form fields will go here in future */}
//     </div>
//   );
// };

// export default InvoicePage;



